import { render } from "./PayrunProses.vue?vue&type=template&id=8b0d2b22"
import script from "./PayrunProses.vue?vue&type=script&lang=js"
export * from "./PayrunProses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__